<div class="app-dialog-shell">
  <div mat-dialog-title class="app-dialog-shell__header">
    <div class="app-dialog-shell__title-group">
      <div class="app-dialog-shell__title-icon">
        <mat-icon>logout</mat-icon>
      </div>
      <div class="app-dialog-shell__title-copy">
        <h1 class="app-dialog-shell__title">Sign out with running environments?</h1>
        <p class="app-dialog-shell__subtitle">You can stop active environments first to avoid burning unused credits.</p>
      </div>
    </div>
    <button tabindex="-1" mat-icon-button type="button" class="app-dialog-shell__close" (click)="onNoClick()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="loading">
    <mat-progress-bar *ngIf="loading" color="accent" mode="indeterminate"></mat-progress-bar>
  </div>

  <div mat-dialog-content class="app-dialog-shell__body">
    <p>Are you sure you want to sign out while one or more environments are still running?</p>
    <div class="app-dialog-warning sign-out-dialog__warning">
      <mat-icon>savings</mat-icon>
      <span>You can save credit hours by stopping unused environments before signing out.</span>
    </div>
  </div>

  <div mat-dialog-actions class="app-dialog-shell__actions app-dialog-shell__actions--split">
    <section class="dont-show-again-section" style="display: none;">
      <mat-checkbox color="primary" class="example-margin" [(ngModel)]="dontShowAgain" [disabled]="loading">Don’t show again</mat-checkbox>
    </section>
    <div class="sign-out-dialog__actions">
      <button mat-stroked-button type="button" (click)="onSignOut()">Sign out</button>
      <button mat-flat-button cdkFocusInitial color="primary" type="button" (click)="onStopAndSignOut()" [disabled]="loading">Stop and sign out</button>
    </div>
  </div>
</div>
